import React from 'react';
import { NotifyOutsideClick } from 'core/components';
import { defaultTemplate } from 'core/hoc';
import { stubTrue } from 'lodash';

function BaasicTableExportTemplate({
	t,
	viewStore: { setVisibility, toggleVisibility, visible, disableExport, exportData },
}) {
	return (
		<NotifyOutsideClick action={() => setVisibility(false)}>
			<div className="header__profile" onClick={toggleVisibility}>
				<div>
					<span className="spc--right--tny">{t('EXPORTCSV.EXPORT')}</span>
					<i className="fa fa-angle-down spc--left--med" />
				</div>
				<div className={'header__profile--dropdown' + (visible ? ' active' : '')}>
					<ul>
						<li className="header__profile--dropdown__item" onClick={disableExport ? () => {} : () => exportData()}>
							{t('EXPORTCSV.EXPORTCURRENT')}
						</li>
						<li className="header__profile--dropdown__item" onClick={disableExport ? () => {} : () => exportData(true)}>
							{t('EXPORTCSV.EXPORTALL')}
						</li>
					</ul>
				</div>
			</div>
		</NotifyOutsideClick>
	);
}

export default defaultTemplate(BaasicTableExportTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/components/table/BaasicTableExportTemplate.jsx